/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProvisioningNotificationStatusEnum } from './provisioningNotificationStatusEnum';
import { ProvisioningNotificationSourceTypeEnum } from './provisioningNotificationSourceTypeEnum';


export interface BillingProvisioningRequestPostSpec { 
    tenant_id?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    saas_transaction_id: string;
    action?: string;
    sku?: string;
    serial_number?: string;
    quantity?: string;
    subscription_type?: string;
    pla?: string;
    service_start_date?: string;
    service_end_date?: string;
    erp_cust_acct_number?: string;
    country_code?: string;
    new_tenant_required?: string;
    information?: string;
    status: ProvisioningNotificationStatusEnum;
    info?: string;
    source_type: ProvisioningNotificationSourceTypeEnum;
}
export namespace BillingProvisioningRequestPostSpec {
}


